import React, { useState } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import DialogModal from '../../../components/DialogModal';
import DropdownSelect from '../../../components/DropdownSelect';
import academicTermsApis from '../../../apis/academicTerms';
import {
  AcademicYearTermsRequestBody,
  AddAcademicTermModalProps
} from '../types';
import TextInputWithIcon from '../../../components/TextInputWithIcon';

const AddAcademicTermModal: React.FC<AddAcademicTermModalProps> = ({
  open,
  onClose,
  fetchData,
  onApiSuccessAndFailure,
  academicYear,
  grade,
  division,
  availableAcademicYearTermOption,
  school,
  previousAcademicTerms
}) => {
  const [termId, setTermId] = useState('');
  const [orderSequence, setOrderSequence] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleModalClose = () => {
    onClose();
    setTermId('');
    setOrderSequence(0);
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const payload: AcademicYearTermsRequestBody = {
        academicYearTerms: [
          {
            academicYear,
            grade,
            division,
            terms: [
              ...previousAcademicTerms,
              {
                termId: termId,
                orderSequence: orderSequence
              }
            ]
          }
        ]
      };
      await academicTermsApis.upsertAYTerms(school, payload);
      onApiSuccessAndFailure(true, 'add');
      fetchData();
      handleModalClose();
    } catch (error) {
      console.error('Error adding academic term:', error);
      onApiSuccessAndFailure(false, 'add');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogModal
      open={open}
      onClose={handleModalClose}
      title='Add Term'
      maxWidth='sm'
      actions={
        <>
          <Button
            onClick={handleModalClose}
            color='secondary'
            variant='outlined'
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color='primary'
            variant='contained'
            disabled={isLoading || !termId}
          >
            {isLoading ? <CircularProgress size={24} color='inherit' /> : 'Add'}
          </Button>
        </>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextInputWithIcon
          label='Academic Year'
          name='academicYear'
          required
          value={academicYear}
          fullWidth
          disabled
        />
        <TextInputWithIcon
          label='Grade'
          name='grade'
          required
          value={grade}
          fullWidth
          disabled
        />
        <TextInputWithIcon
          label='Division'
          name='division'
          required
          value={division}
          fullWidth
          disabled
        />
        <DropdownSelect
          label='Term'
          placeholder='Select Term'
          name='termId'
          value={termId}
          options={availableAcademicYearTermOption}
          onChange={(event) => setTermId(event.target.value as string)}
          required
        />
        <TextInputWithIcon
          label='Sequence No.'
          name='orderSequence'
          type='number'
          value={orderSequence}
          onChange={(event) => setOrderSequence(Number(event.target.value))}
          fullWidth
          slotProps={{ htmlInput: { min: 0 } }}
        />
      </Box>
    </DialogModal>
  );
};

export default AddAcademicTermModal;
